import store from '../stores/store';

export const setSelectedTab = (tab) => {
    return {
        type: 'SET_SELECTED_TAB',
        value: tab
    }
};

export const setSideNavs = (sideNavs) => {
    return {
        type: 'SET_SIDE_NAVS',
        value: sideNavs
    }
};

export const setApiStatus = (status) => {
    return {
        type: 'SET_API_STATUS_VALUE',
        value: status
    }
};

export const setApprovalList = (approvalList) => {
    return {
        type: 'SET_APPROVAL_LIST',
        value: approvalList
    }
};

export const getApprovalList = (flowId) => {
    return {
        type: 'GET_APPROVAL_LIST',
        flowId: flowId
    }
};

export const setApprovalFlowContext = (approvalFlowContext) => {
    return {
        type: 'SET_APPROVAL_FLOW_CONTEXT',
        value: approvalFlowContext
    }
};

export const getApprovalFlows = (customerGuid) => {
    return {
        type: 'GET_APPROVAL_FLOW',
        customerGuid: customerGuid
    }
}

export const getApprovalDetails = (approvalID) => {
    return {
        type: 'GET_APPROVAL_DETAILS',
        approvalId: approvalID
    }
};

export function refreshApprovalList(workFlowId,context,customerGuid,approvalId){

    return function(dispatch){
        store.dispatch(setApprovalFlowContext(context));
        if(context === 'APPROVAL_LIST'){           
            store.dispatch(getApprovalList(workFlowId));
        }
        else if(context === 'APPROVAL_DETAILS'){
            store.dispatch(getApprovalDetails(approvalId));
        }
        
    };
}